module.exports = __webpack_public_path__ + "img/avatar_0.3425fc41.jpg";